import { render, staticRenderFns } from "./terms-and-conditions-dialog.component.vue?vue&type=template&id=14409169&scoped=true&"
import script from "./terms-and-conditions-dialog.component.vue?vue&type=script&lang=ts&"
export * from "./terms-and-conditions-dialog.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14409169",
  null
  
)

export default component.exports